/**
 * @generated SignedSource<<f75f2bb19aa9a8859c30524b32e57172>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectActivityManagementRound_Booking$data = {
  readonly rounds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly player: {
          readonly id: string;
        } | null | undefined;
        readonly roundRate: {
          readonly rate: {
            readonly id: string;
            readonly name: string;
          };
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SelectActivityManagementRound_Booking";
};
export type SelectActivityManagementRound_Booking$key = {
  readonly " $data"?: SelectActivityManagementRound_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectActivityManagementRound_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectActivityManagementRound_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoundRate",
                  "kind": "LinkedField",
                  "name": "roundRate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "c11d5e87a0a2f1f6264873801a12dda3";

export default node;
